<template>
  <!--DataGrid -->
  <button type="button" class="btn btn-danger" @click="add">
    <font-awesome-icon icon="plus" />New
  </button>
  <div class="card">
    <PrimeDataTable
      ref="dt"
      :value="data"
      :paginator="true"
      :rows="10"
      dataKey="pkey"
    >
      <PrimeColumn :exportable="false" style="width: 6rem">
        <template #body="slotProps">
          <div class="btn-group" role="group">
            <button class="btn btn-success" @click="edit(slotProps.data)">
              <font-awesome-icon icon="edit" />
            </button>
            <button
              class="btn btn-outline-success"
              @click="confirmDelete(slotProps.data)"
            >
              <font-awesome-icon icon="trash" />
            </button>
          </div>
        </template>
      </PrimeColumn>

      <PrimeColumn
        field="cusNo"
        header="客戶編號"
        :sortable="true"
      ></PrimeColumn>
      <PrimeColumn
        field="escsno"
        header="新竹客代"
        :sortable="true"
      ></PrimeColumn>
      <PrimeColumn
        field="weight_Min"
        header="重量Min"
        :sortable="true"
      ></PrimeColumn>
      <PrimeColumn
        field="weight_Max"
        header="重量Max"
        :sortable="true"
      ></PrimeColumn>
      <PrimeColumn
        field="description"
        header="描述"
        :sortable="true"
      ></PrimeColumn>
    </PrimeDataTable>
  </div>

  <!--Edit Modal -->
  <PrimeDialog
    v-model:visible="isShowDialog"
    :style="{ width: '950px' }"
    header="新竹客代維護"
    :modal="true"
    class="p-fluid"
  >
    <component
      :is="component_name"
      :item="item"
      @save="detailSave"
      @close="detailClose"
    ></component>
  </PrimeDialog>

  <PrimeConfirmDialog></PrimeConfirmDialog>
</template>

<script>
import service from "../service/Appservice";
export default {
  props: ["agentNo"],

  data() {
    return {
      isAddNew: false,
      component_name: "my-modal-agentescsno",
      item: null,
      selectedItems: null,
      data: null,
      isShowDialog: false,
      keyField: "pkey",
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    clientId() {
      return this.$store.state.user?.clientId;
    },
  },
  service: null,
  created() {
    this.service = new service();
  },
  mounted() {
    this.search();
  },
  methods: {
    /////對話視窗回復事件/////////////////////////////////
    detailSave: function (obj) {
      this.isShowDialog = false;
      if (this.isAddNew) {
        this.array_addItem(this.data, obj);
      } else {
        this.array_updateItem(this.data, obj, this.keyField);
      }
    },

    detailClose: function () {
      this.isShowDialog = false;
    },
    ////////搜尋/////////////////////////////////////
    search() {
      this.service.getAgentEscsno(this.clientId, this.agentNo).then((data) => {
        console.log(data);
        this.data = [...data];
      });
    },
    //////新增,修改,刪除////////////////////////////////////////////
    add() {
      this.isAddNew = true;
      this.item = {};
      this.item.clientID = this.clientId;
      this.item.agentNo = this.agentNo;
      this.isShowDialog = true;
    },
    edit(rowSelect) {
   this.isAddNew = false;
        console.log("edit");
      console.log(rowSelect);
      this.item = rowSelect;
      this.isShowDialog = true;
    },
    confirmDelete(selectItem) {
      console.log(selectItem)
       var yes = confirm('你確定要刪除?');
       if (yes) {
            console.log(selectItem);
            this.delete(selectItem);
        } 
    },
    delete(selectItem) {
      var self = this;
      this.service
        .deleteAgentEscsno(selectItem)
        .then(() => {
          this.array_deleteItem(self.data, selectItem, self.keyField);
        }).catch((error) => {
          if (error.response) {
            alert('刪除失敗');
            // 请求已发出，但服务器响应的状态码不在 2xx 范围内
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
        });
    },
  },
};
</script>
 